'use client';
import { type sendEventProps } from '../newRelic';
import { trackEvent } from '../newRelic/track';

export const SendNavigatorData = ({
  app,
  instanceType,
}: {
  app: sendEventProps['app'];
  instanceType?: sendEventProps['instanceType'];
}) => {
  const screenSize = `${window.screen.width}x${window.screen.height}`;
  const memory = (navigator as any)?.deviceMemory || 0;
  const platform = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    ? 'mobile'
    : 'desktop';
  trackEvent({
    app,
    instanceType,
    type: 'stat',
    data: { userAgent: navigator.userAgent, screenSize, memory, platform },
  });
};
